import { gql } from '@apollo/client';

export const PROCESSING_REPORTS_VERIFICATION_MUTATION = gql`
  mutation startInterrogationsReportFlow {
    startInterrogationsReportFlow {
      commandId
      correlationId
    }
  }
`;

export const EXPORT_REPORTS_VERIFICATION_MUTATION = gql`
  mutation exportReportsVerificationList($filters: ExportReportsVerificationListInput) {
    exportReportsVerificationList(filters: $filters) {
      fileId
      fileName
      filePath
    }
  }
`;
